import * as Yup from "yup";

import { validateNinWithSpaceStrict } from "@storebrand-digital/storebrand-common-validation";
import { TextManager } from "Components/TextContext";
import { ageInMonthsFromNin } from "./ninValidationHelpers";

export const isInfantInMonthsNin = 2;
export const isInfantInMonths = 3;
export const isAdultInMonths = 216;
export const defaultMaxAge = 69;

const MASKED_NIN_REGEX = /^\d{6}\*{5}$/;
const { getText } = TextManager;

export const isMaskedNin = (nin: string | undefined): boolean =>
  !!nin && MASKED_NIN_REGEX.test(nin);

export const maskedNinSchema = (): Yup.StringSchema =>
  Yup.string().when("ownerSocialSecurityNumber", {
    is: isMaskedNin,
    then: (schema) =>
      schema.required(getText("customerform.validation.nin-required")),
    otherwise: (schema) => schema.concat(ninSchema()),
  });

export const ninSchema = (): Yup.StringSchema<string> => {
  return Yup.string()
    .test("isNin", getText("customerform.validation.nin-valid"), (value) => {
      const regexMaskedNin = /^\d{6}\*{5}$/;
      if (value?.match(regexMaskedNin)) {
        return true;
      }
      return validateNinWithSpaceStrict(value).valid;
    })
    .required(getText("customerform.validation.nin-required"))
    .when("dateOfBirth", {
      is: (dateOfBirth: string) => dateOfBirth !== undefined,
      then: (schema) =>
        schema.test(
          "validChildAge",
          getText("customerform.validation.nin-childageinvalid"),
          function (value) {
            // TODO: Update max age when doing final implementation of new child insurance rules
            // TBD: How to differentiate between child and aka child
            const ageInMonths = ageInMonthsFromNin(value);
            if (ageInMonths) {
              return (
                ageInMonths > isInfantInMonthsNin &&
                ageInMonths < isAdultInMonths
              );
            }
            return true;
          },
        ),
    });
};
